import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom, isDevMode, ErrorHandler } from '@angular/core';
import { of } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { AuthService } from './core/services/auth.service';
import { LicenseService } from './core/services/license.service';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { MessageService, ConfirmationService } from 'primeng/api';
import { provideServiceWorker } from '@angular/service-worker';

export function initApp(authService: AuthService, licenseService: LicenseService) {
  return () => {
    authService.initFromStorage();
    if (authService.isLoggedIn()) {
      licenseService.validateOnStartup().subscribe({
        error: (err) => console.error('License validation failed', err)
      });
    }
    return of(null);
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    MessageService,
    ConfirmationService,
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService, lic: LicenseService) => initApp(auth, lic),
      deps: [AuthService, LicenseService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }
]
};
